import React from "react";
import { Loader } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import { ProductData } from ".";

type DistrictLevelData = {
	district: string;
	additional_potential_quantity: number;
	benefits_from_incremental_sales: number;
	potential_incremental_sales: number;
	recomendedGM: number;
};

type Props = {
	data: DistrictLevelData[];
	selectedDistrict: string | null;
	handleDistrictClick: (district: string | null) => void;
	productData: ProductData[] | null;
	loading: boolean;
	handleProductClick: (product: ProductData | null) => void;
	selectedProductId: string | null;
};

const PortfolioTable = ({
	data,
	selectedDistrict,
	handleDistrictClick,
	productData,
	loading,
	handleProductClick,
	selectedProductId,
}: Props) => {
	if (selectedProductId) {
		setTimeout(() => {
			document
				.getElementById(`selected${selectedProductId}`)
				?.scrollIntoView({ behavior: "smooth", block: "nearest" });
		}, 100);
	} else if (selectedDistrict) {
		setTimeout(() => {
			document
				.getElementById(selectedDistrict)
				?.scrollIntoView({ behavior: "smooth", block: "center" });
		}, 100);
	}

	const { districtTotalData } = data.reduce(
		(initial: any, current: any) => {
			return {
				...initial,
				districtTotalData: {
					additional_potential_quantity:
						initial.districtTotalData
							.additional_potential_quantity +
						current.additional_potential_quantity,
					benefits_from_incremental_sales:
						initial.districtTotalData
							.benefits_from_incremental_sales +
						current.benefits_from_incremental_sales,
					potential_incremental_sales:
						initial.districtTotalData.potential_incremental_sales +
						current.potential_incremental_sales,
				},
			};
		},
		{
			districtTotalData: {
				additional_potential_quantity: 0,
				benefits_from_incremental_sales: 0,
				potential_incremental_sales: 0,
			},
		}
	);
	console.log("data", data);

	return (
		<>
			{loading ? (
				<div className="w-full h-full">
					<Loader
						className="w-full h-full relative"
						size="md"
						inverse
						center
						content="loading..."
					/>{" "}
				</div>
			) : (
				<table className="common-table-ui !h-[92%]">
					<thead>
						<tr>
							<th rowSpan={2}>District</th>
							{selectedDistrict && (
								<>
									<th rowSpan={2}>
										Product
										<br />
										Group ID
									</th>
									<th rowSpan={2}>
										Product Group
										<br />
										Description
									</th>
								</>
							)}
							<th colSpan={selectedDistrict ? 4 : 3}>
								District Opportunity
							</th>
						</tr>
						<tr>
							<th>Additional Potential Quantity</th>
							<th>Potential Incremental Sales ($)</th>
							{selectedDistrict && (
								<th>Recommended SKU Gross Margin (%)</th>
							)}
							<th>Benefit from Incremental Sales ($)</th>
						</tr>
					</thead>
					<tbody>
						{data?.map((d: DistrictLevelData, index: number) => {
							return (
								<React.Fragment key={d.district + index}>
									<tr
										id={d.district}
										key={index}
										className={`${
											selectedDistrict === d.district
												? "selected-row font-bold"
												: selectedDistrict
												? "low-opacity"
												: ""
										}`}
									>
										<td
											className="flex items-center"
											onClick={(e: any) => {
												e.stopPropagation();
											}}
										>
											{selectedDistrict === d.district ? (
												<MinusRoundIcon
													className="plusIcon mr-[1vh]"
													onClick={() =>
														handleDistrictClick(
															null
														)
													}
												/>
											) : (
												<PlusRoundIcon
													className="plusIcon mr-[1vh]"
													onClick={() => {
														handleDistrictClick(
															d.district
														);
													}}
												/>
											)}
											{d.district}
										</td>
										{selectedDistrict && productData && (
											<>
												<td></td>
												<td></td>
											</>
										)}
										<td>
											{numberFormatter(
												d.additional_potential_quantity,
												0
											)}
										</td>
										<td>
											{numberFormatter(
												d.potential_incremental_sales,
												0,
												"$"
											)}
										</td>
										{selectedDistrict && <td></td>}{" "}
										{/* Add empty cell for GM */}
										<td>
											{numberFormatter(
												d.benefits_from_incremental_sales,
												0,
												"$"
											)}
										</td>
									</tr>
									{selectedDistrict === d.district &&
									productData ? (
										productData.map(
											(product: ProductData) => (
												<tr
													id={
														selectedProductId ===
														product.product_group_id
															? `selected${product.product_group_id}`
															: "unselected"
													}
													className={`cursor-pointer ${
														selectedProductId ===
														product.product_group_id
															? "selected-row font-bold"
															: "font-inherit"
													}`}
													key={
														product.product_group_id
													}
													onClick={() =>
														handleProductClick(
															product.product_group_id ===
																selectedProductId
																? null
																: product
														)
													}
												>
													<td></td>
													<td>
														{
															product.product_group_id
														}
													</td>
													<td>
														{
															product.product_group_description
														}
													</td>
													<td>
														{numberFormatter(
															product.additional_potential_quantity,
															0
														)}
													</td>
													<td>
														{numberFormatter(
															product.potential_incremental_sales,
															0,
															"$"
														)}
													</td>
													<td>
														{numberFormatter(
															product.recomendedGM *
																100,
															2
														)}
														%
													</td>{" "}
													{/* Display GM */}
													<td>
														{numberFormatter(
															product.benefits_from_incremental_sales,
															0,
															"$"
														)}
													</td>
												</tr>
											)
										)
									) : (
										<></>
									)}
								</React.Fragment>
							);
						})}
						{data.length == 0 && (
							<tr className="h-[47.5vh] text-[#a4f504]">
								<td colSpan={4}>No data available</td>
							</tr>
						)}
						<tr className="portfolio-total-row">
							<td className="center">Total</td>
							{selectedDistrict && productData && (
								<>
									<td></td>
									<td></td>
								</>
							)}
							<td>
								{numberFormatter(
									districtTotalData.additional_potential_quantity,
									0,
									"$"
								)}
							</td>
							<td>
								{numberFormatter(
									districtTotalData.potential_incremental_sales,
									0,
									"$"
								)}
							</td>
							{selectedDistrict && <td></td>}{" "}
							{/* Empty cell for GM */}
							<td>
								{numberFormatter(
									districtTotalData.benefits_from_incremental_sales,
									0,
									"$"
								)}
							</td>
						</tr>
					</tbody>
				</table>
			)}
		</>
	);
};
export default PortfolioTable;
